/**
 * This is used a a global switch for loading current-YEAR.js file
 * Simple & effective and only need to change it here
 */

module.exports = {
	currentYear: 2025
}